import script from "./SelectedUsersAvatarsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectedUsersAvatarsList.vue?vue&type=script&setup=true&lang=js"

import "./SelectedUsersAvatarsList.vue?vue&type=style&index=0&id=784ecf64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-784ecf64"]])

export default __exports__